import { render, staticRenderFns } from "./wxuser.vue?vue&type=template&id=28c27332&"
import script from "./wxuser.vue?vue&type=script&lang=js&"
export * from "./wxuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports